import styled from "styled-components"

const NavigationBar = styled.div`
  margin: 0;
  position: absolute;
  top: 0;
  left: 50px;
  right: 50px;
  background: rgba(0, 0, 0, 0.3);
  padding: 10px 0 20px 0;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  z-index: 100;
`

export default NavigationBar



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationBar.js